import { render, staticRenderFns } from "./RptLateReturns.vue?vue&type=template&id=2b2e176a&scoped=true&"
import script from "./RptLateReturns.vue?vue&type=script&lang=js&"
export * from "./RptLateReturns.vue?vue&type=script&lang=js&"
import style0 from "./RptLateReturns.vue?vue&type=style&index=0&id=2b2e176a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e176a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VSimpleTable,VTextField})
